// questo è il controller della modale 
(function () {
    'use strict';
    var controllerId = 'contrattoIncontroAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'contrattoIncontro', 'tipoIncontri', contrattoIncontroAddEditFn]);

    // Le modali lavorano con $scope e non con vm
    function contrattoIncontroAddEditFn($scope, $uibModalInstance, $filter, datacontext, common, contrattoIncontro, tipoIncontri) {
        $scope.contrattoIncontro = contrattoIncontro;           // posso visualizzare e modificare il record nella modale        
        $scope.tipoIncontri = tipoIncontri;
        if ($scope.contrattoIncontro.Id == 0) {   // sono nel nuovo
            $scope.titolo = 'Nuovo incontro';
        }
        else {  // sono in modifica
            $scope.titolo = 'Modifica incontro'; 
        }

        // gestione di DataPrevista
        if ($scope.contrattoIncontro.DataPrevista && $scope.contrattoIncontro.DataPrevista != null)
            $scope.contrattoIncontro.DataPrevista = new Date($scope.contrattoIncontro.DataPrevista);

        // gestione di DataEffettuato
        if ($scope.contrattoIncontro.DataEffettuato && $scope.contrattoIncontro.DataEffettuato != null)
            $scope.contrattoIncontro.DataEffettuato = new Date($scope.contrattoIncontro.DataEffettuato);

        //DatePicker (gestione del calendario)
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
            $scope.opened1 = false;
        };
        $scope.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = !$scope.opened1;
            $scope.opened = false;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {        // quando clicco sul bottone Salva della modale
            if (isValid) {                      // se il valore passato è valido
                var result = {};
                if ($scope.contrattoIncontro.Id == 0) {   // sono nel bottone per l'aggiunta del nuovo elemento
                    result = addItem($scope.contrattoIncontro);
                }
                else {  // sono in modifica

                    result = editItem($scope.contrattoIncontro); // metto in result l'oggetto tornato dal server a seguito dell'aggiornamento (può essere nullo se non va a buon fine)
                }        
                $uibModalInstance.close(result);                    // la modale viene chiusa tornando al controller chiamante (contratto) l'oggetto appena modificato
            }
        };

        $scope.cancel = function () {         // quando clicco su Annulla la modale viene chiusa
            $uibModalInstance.dismiss('cancel');
        };


        // Questa è la modale che è utilizzata sia per la modifica di un incontro già esistente, che per l'aggiunta di uno nuovo.
        // Conseguentemente avremo sia il metodo editItem per la modifica (click su tasto dettaglio) che il metodo addItem per l'aggiunta (click su tasto "Aggiungi")
        
        // Modifica (tasto dettaglio)
        function editItem(item) {
            return datacontext.contrattoIncontro_update(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;          // In questo caso l'aggiornamento non è andato a buon fine
                return data;                                                        // altrimenti torna l'oggetto modificato
            });
        }

        // Aggiunta (tasto Aggiungi)
        function addItem(item) {
            return datacontext.contrattoIncontro_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;          // In questo caso l'aggiornamento non è andato a buon fine
                return data;                                                        // altrimenti torna il nuovo oggetto
            });
        }
    }
})();